import { t } from '@moovly/i18n';
import { Button, useModal } from '@moovly/ui';
import * as React from 'react';
import CreateLibraryModal from '../modals/CreateLibraryModal';

interface LibraryCreateButtonContainerProps {
  label?: string;
}

const LibraryCreateButtonContainer: React.FC<LibraryCreateButtonContainerProps> = ({
  label = t('libraries.create.button'),
}) => {
  const { isOpen, openModal, ...otherModalProps } = useModal();
  return (
    <>
      <Button onClick={openModal} className="btn btn-primary" label={label} />
      {isOpen && <CreateLibraryModal {...otherModalProps} />}
    </>
  );
};

export default LibraryCreateButtonContainer;
